import React, { useState } from 'react';

import Tooltip from 'components/Tooltip';
import Truncate from "react-truncate";

const TruncatedTextWithTooltip = ({ content, className, maxWidth = 200, placement = "top" }) => {
    const [tooltip, setTooltip] = useState(false);
  
    const handleTooltip = (isTruncated) => {
      setTooltip(isTruncated)
    }
  
    return (
      <Tooltip placement={placement} disabled={!tooltip} content={content}>
        <span className={className}>
          <Truncate lines={1} width={maxWidth} ellipsis="..." onTruncate={handleTooltip}>
            {content}
          </Truncate>
        </span>
      </Tooltip>
    )
}

export default TruncatedTextWithTooltip;